export var HubSpotQuestionType;
(function (HubSpotQuestionType) {
    HubSpotQuestionType["CHECKBOX"] = "checkbox";
    HubSpotQuestionType["RADIO"] = "radio";
    HubSpotQuestionType["TEXTAREA"] = "textarea";
})(HubSpotQuestionType || (HubSpotQuestionType = {}));
//# sourceMappingURL=hubspot-question-type.enum.js.map